import { ReactNode } from "react";
import { createFastContext } from "../../../../../contexts/createFastContext";

interface IState {
    dataIndex?: number
    hoverId?: string
}

const {
    Provider,
    useStore: useConversation,
    setStore: setConversation,
    getStore: getConversation,
    callEvent: callEventConversation
} = createFastContext<IState, {
}>({

});

const ConversationProvider = ({ children, ...args }: {
    children: ReactNode,
} & Partial<IState>) => {

    return <Provider props={{ ...args }} >
        {children}
    </Provider>
}


export { callEventConversation, ConversationProvider, getConversation, setConversation, useConversation };

